import * as React from "react";
import { bugsnagClient } from "../bugsnag";

class ErrorBoundary extends React.Component<
  {
    label: string;
    children: any;
  },
  any
> {
  constructor(props: any) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: any) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(
    e: Error,
    errorInfo: {
      componentStack: string;
    }
  ): void {
    const metaData = {
      type: `Error Boundary triggered for ${this.props.label}`,
      label: this.props.label,
      message: e.message,
      stack: JSON.stringify(e.stack),
      componentStack: errorInfo.componentStack,
    } as const;
    bugsnagClient?.leaveBreadcrumb(
      `Error Boundary triggered for ${this.props.label}`,
      metaData
    );
    bugsnagClient?.notify(e, (ev) => {
      ev.severity = "error";
      ev.addMetadata("ErrorBoundary", {
        label: this.props.label,
      });
    });

    if (/Failed to fetch dynamically imported module:(.*).js/.test(e.message)) {
      // This error occurs when existing clients try to navigate after a new deploy goes out. It is resolved by refreshing the html.
      if (window.sessionStorage.getItem("lastErrorMessage") !== e.message) {
        // Prevent infinite refresh loop by storing the last error message and only attempting refresh once
        window.sessionStorage.setItem("lastErrorMessage", e.message);
        window.location.reload();
      }
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            margin: "20%",
          }}
        >
          <h2
            style={{
              textAlign: "center",
            }}
          >
            Something went wrong.
          </h2>
          <h4
            style={{
              textAlign: "center",
            }}
          >
            Please contact Backpack Support if the problem persists.
          </h4>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
